import styles from './Social.module.scss';

export const SocialContainer = () => {
    return (
        <div className={styles['social-container']}>
            <div className={styles['black-bg']}>
                <div className={styles['social-wrapper']}>
                    <div className={styles['title']}>
                        <p>Connect With Us Online</p>
                        <p>Social Channels</p>
                    </div>
                    <div className={styles['social-button-wrapper']}>
                        <a href="https://www.linkedin.com/in/rebeccastameywhite/" target="_blank"
                           rel="noopener noreferrer" >
                        <img src="./social-channel-linkedin-button.svg"
                             alt="linkedin-icon"/>
                        </a>
                    </div>
                </div>

            </div>
        </div>
    )
};